import { createApp } from 'vue';
import App from './App.vue';
import './registerServiceWorker';
/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import router from './router';
import store from './store';
import ElementPlus from 'element-plus';
import { abilitiesPlugin } from '@casl/vue';
// imports for app initialization
import ApiService from '@/core/services/ApiService';
import ability from '@/core/plugins/casl/ability';
import { initApexCharts } from '@/core/plugins/apexcharts';
import { initInlineSvg } from '@/core/plugins/inline-svg';
import { initVeeValidate } from '@/core/plugins/vee-validate';
import { initIcons } from '@/core/plugins/icons';
import { initToastification } from './core/plugins/toastification';
import firebase from '@/core/config/FirebaseConfig';
import '@/core/plugins/keenthemes';
import '@/core/plugins/prismjs';
import 'bootstrap';
import 'vue3-ts-picker/dist/vue3-ts-picker.css';
import { i18n } from './localization/index';
import CKEditor from '@ckeditor/ckeditor5-vue';
import { BumaUiIcons } from '@buma-dev/buma-ui';
import BumaUiV2 from '@buma-dev/buma-ui-v2';
import '@buma-dev/buma-ui-v2/dist/style.css';
const app = createApp(App);
// Load every component from ./components/inputs/form
const req = require.context('./components/inputs/form', false, /\.(js|vue)$/i);
for (const key of req.keys()) {
    const name = key.match(/\w+/)[0];
    app.component(name, req(key).default);
}
app.use(BumaUiIcons);
app.use(store);
app.use(router);
app.use(ElementPlus);
app.use(firebase);
app.use(CKEditor);
app.use(BumaUiV2);
ApiService.init(app);
initApexCharts(app);
initInlineSvg(app);
initIcons(app);
initVeeValidate();
initToastification(app);
app.use(i18n);
app.use(abilitiesPlugin, ability, {
    useGlobalProperties: true
});
app.mount('#app');
